import { render, staticRenderFns } from "./ChannelsEligibility.vue?vue&type=template&id=de6db292"
import script from "./ChannelsEligibility.vue?vue&type=script&lang=js"
export * from "./ChannelsEligibility.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports